import { render, staticRenderFns } from "./MovePackingConditionsRadioField.vue?vue&type=template&id=56a1f564"
import script from "./MovePackingConditionsRadioField.vue?vue&type=script&lang=js"
export * from "./MovePackingConditionsRadioField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports